@if (breakpointChanges$ | async; as isSmallScreen) {
  @if (isSmallScreen.matches ) {
    <ng-content />
  }
}
